import type { Configuration } from 'modules/integrations/public'

export const EXPENSES_SYNC_CONFIGURATION: Configuration = {
  origin: 'expenses',
  syncableType: 'expensesexpensable',
  syncableStatusesFilter: ['synced', 'failed', 'pending'],
}
